import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestState, selectFeatureState, selectIsProgressBar, selectProgress } from '../../store/reducers/rest.reducer';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {
  progress$ = this.store.pipe(select(selectProgress));
  isProgressBar$ = this.store.pipe(select(selectIsProgressBar));
  stateClass$ = this.store.pipe(select(selectFeatureState), map(res => {
    if (res.total > 0) {
      if (res.completed === 0) {
        return 'begin';
      }
      else if (res.completed !== res.total) {
        return 'loading';
      }
      else if (res.completed === res.total) {
        return 'completing finished';
      }
    }
  }));
  closeable = false;
  closed = false;

  constructor(private store: Store<RestState>, private cd: ChangeDetectorRef) {
    // Fix issue: Expression changed before check on Dev Mode
    // setTimeout(() => this.isProgressBar$ = this.store.pipe(select(selectIsProgressBar)), 0);
  }

  ngOnInit() {
    this.reset();
  }

  closeSpinLoading() {
    this.closed = true;
    this.cd.markForCheck();
  }

  reset() {
    this.closeable = false;
    this.closed = false;
    // setTimeout(() => {
    //   this.closeable = true;
    //   this.cd.markForCheck();
    // }, 10000);
    this.cd.markForCheck();
  }
}
